import type { IChatItem } from '@/types';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { getLlmModelHeader, LLM_FUNCTION_ID } from '@eureka/utils/llm-model';

export const TechSchemeApiService = Symbol('TechSchemeApiService');

export interface TechSchemeApiService {
    chatRaw(projectId: string, level: 'FIRST' | 'SECOND' | 'IDEA', query?: string): Promise<IChatItem[]>;
}

@injectable()
export class TechSchemeApiServiceImpl extends PsHttpService implements TechSchemeApiService {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
                ...getLlmModelHeader(LLM_FUNCTION_ID.QUICK_RESEARCH),
            },
        };
    }

    chatRaw(projectId: string, level: 'FIRST' | 'SECOND' | 'IDEA', query = '') {
        const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/chat`
        return this.post<PatSnapCommonResponseData<IChatItem[]>>({
            url,
            data: {
                project_id: projectId,
                level,
                query,
            },
        }).then(res => {
            return res.data as IChatItem[]
        })
    }
}
